import { useAuth } from '@/lib/auth-context';

export default function OfflineModeBanner() {
  const { offlineMode } = useAuth();

  if (!offlineMode) return null;

  return (
    <div className="mx-auto my-3 w-full max-w-4xl rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-sm">
      <strong className="font-semibold">Offline mode.</strong>{' '}
      Netlify functions are unavailable right now, so we’re serving cached data. Some actions may be delayed, but we’ll
      resync automatically when the connection returns.
    </div>
  );
}
